import React from "react";
import { Button, Card, Col, Modal, Row, Stack, Table } from "react-bootstrap";
import { Email, Person, Phone } from "../assets/svgs/Icons";
import ButtonWithIcon from "./ButtonWithIcon";

export default function ViewItemModal({
  selectedItem,
  setSelectedItem,
  showView,
  setShowView,
}) {
  if (!selectedItem) {
    return <></>;
  }

  const handleClose = () => {
    setShowView(false);
    setSelectedItem(null);
  };

  const sendEmail = () => {
    window.location.href = "mailto:" + selectedItem.email;
  };

  const callPhone = () => {
    window.location.href = "tel:" + selectedItem.phone;
  };

  return (
    <>
      <Modal
        show={showView}
        onHide={handleClose}
        size="lg"
        fullscreen="sm-down"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {selectedItem.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ margin: "5%", padding: "0px" }}>
          <Row className="mb-3" xs={1} md={1} lg={2}>
            <Col className="mb-3">
              <Card>
                <Card.Header>Kontakt</Card.Header>
                <Card.Body style={{ padding: "5%" }}>
                  <Stack direction="horizontal" className="mb-3">
                    <div className="d-flex flex-column align-items-center">
                      <ButtonWithIcon
                        variant="outline-primary"
                        Icon={Person}
                        text={""}
                        clickable={false}
                      />
                    </div>
                    <Card.Text
                      className="w-100 d-flex justify-content-end"
                      style={{ textAlign: "end" }}
                    >
                      {selectedItem.name}
                    </Card.Text>
                  </Stack>
                  <Stack direction="horizontal" className="mb-3">
                    <div className="d-flex flex-column align-items-center">
                      <ButtonWithIcon
                        variant="outline-success"
                        Icon={selectedItem.contact === "email" ? Email : Phone}
                        text={""}
                        clickable={true}
                        onClick={
                          selectedItem.contact === "email"
                            ? sendEmail
                            : callPhone
                        }
                      />
                    </div>
                    <Card.Text
                      className="w-100 d-flex justify-content-end"
                      style={{ textAlign: "end" }}
                    >
                      {selectedItem.contact === "email" ? (
                        <p
                          style={{
                            textAlign: "end",
                            margin: "0px",
                          }}
                        >
                          {selectedItem.email}
                        </p>
                      ) : (
                        <p
                          style={{
                            textAlign: "end",
                            margin: "0px",
                          }}
                        >
                          {selectedItem.phone}
                        </p>
                      )}
                    </Card.Text>
                  </Stack>
                  <Stack direction="horizontal">
                    <div className="d-flex flex-column align-items-center">
                      <ButtonWithIcon
                        variant="outline-danger"
                        Icon={selectedItem.contact === "email" ? Phone : Email}
                        text={""}
                        clickable={true}
                        onClick={
                          selectedItem.contact === "email"
                            ? callPhone
                            : sendEmail
                        }
                      />
                    </div>
                    <Card.Text
                      className="w-100 d-flex justify-content-end"
                      style={{ textAlign: "end" }}
                    >
                      {selectedItem.contact === "email" ? (
                        <p
                          style={{
                            textAlign: "center",
                            margin: "0px",
                          }}
                        >
                          {selectedItem.phone}
                        </p>
                      ) : (
                        <p
                          style={{
                            textAlign: "center",
                            margin: "0px",
                          }}
                        >
                          {selectedItem.email}
                        </p>
                      )}
                    </Card.Text>
                  </Stack>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Header>Preis und Größe</Card.Header>
                <Card.Body>
                  <Table borderless>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Preis</th>
                        <th style={{ textAlign: "center" }}>Größe</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          {selectedItem.price} €
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {selectedItem.size}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <Card.Header>Beschreibung</Card.Header>
                <Card.Body>
                  <Card.Text>{selectedItem.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose}>Schließen</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
